<template>
  <div id="mainblock">
    <link
      href="https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap"
      rel="stylesheet"
    />
    <introPanel @completed="introCompleted" :showIntro="showIntro"></introPanel>
    <levelStage
      @completed="levelStageCompleted"
      :start="stage"
      :key="levelStageKey"
    ></levelStage>
    <v-container v-show="stage == 2" :key="mainKey">
      <background1></background1>
      <div v-for="(item, i) in myData" :key="i" class="card">
        <v-card
          ref="myCard"
          elevation="24"
          class="mx-auto my-12 col-md-6"
          v-show="blockCount[i] == true"
        >
          <v-row class="my-4 text-center">
            <v-col class="column-block">
              <div class="info-wrapper">
                <div class="readyNextQuestion" v-show="nextQuestionMsgFlag" role="status" aria-live="polite">
                  Preparati!
                </div>
                <div class="counter" v-show="counterFlag" aria-live="off" aria-hidden="true">{{ counter }}</div>
              </div>

              <v-card-text>
                <h1 class="questionText">
                  {{ item.q }}
                </h1>
                <div
                  class="questionResultText"
                  v-html="results[i].answerMsg"
                  role="status"
                  aria-live="polite"
                ></div>
              </v-card-text>
              <v-chip-group
                ref="chipGroup"
                active-class="deep-purple accent-4 white--text"
                column
              >
                <v-container>
                  <v-chip
                    :disabled="results[i].done == true"
                    text-color="white"
                    :color="results[i].chip[chipIndex]"
                    v-for="(ele, chipIndex) in myRandomSeeds[i]"
                    :key="chipIndex"
                    elevation="10"
                    @click="check(i, ele, true)"
                    label
                    large
                    class="answerChip ma-2"
                    >{{ ele }}</v-chip
                  >
                </v-container>
              </v-chip-group>
              <div class="questionInfo">Scegli la lettura corretta</div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-container>
    <finalResult
      v-show="stage == 3"
      :scores="scoreProps"
      :sounds="sounds"
      @action="backToIntro"
    />
  </div>
</template>

<script>
import { data, intro,orig } from "./data1";
import background1 from "./background";
import introPanel from "./intro";
import levelStage from "./levelstage";
import finalResult from "./finalResult";
export default {
  data() {
    return {
      SETCOUNTER: 5,
      myData: data,
      orig: orig,
      levelStageKey: 0,
      mainKey: 1,
      blockCount: new Array(data.length),
      answerMsg: "",
      results: [],
      scores: [],
      scoreProps: [],
      myRandomSeeds: [],
      counter: 0,
      counterAction: undefined,
      nextQuestionMsgFlag: 0,
      counterFlag: 1,
      stage: 0,
      time: 0,
      showIntro: true,
      sounds: {
        click: new Audio("sound/button-3-soundjay.mp3"),
        theme: new Audio("sound/tema.mp3"),
        intro: new Audio("sound/intro.mp3"),
        ok: new Audio("sound/cg-ok.mp3"),
        ko: new Audio("sound/cg-ko.mp3"),
        disable: true,
      },
    };
  },
  components: {
    background1,
    introPanel,
    levelStage,
    finalResult, 
  },
  computed: {},
  watch: {
    "sounds.disable"(newVal, oldVal) {
      if (newVal == true) {
        this.sounds.intro.pause();
      } else {
        this.sounds.intro.play();
      }
    },
    stage(newVal) {},
  },
  created() {
    //modifico il comportamento di results prima di partire
    this.doShuffle();
  },
  mounted() {
    console.log(this.results, "test");
    //this.randomSeeds("一日");

    this.initialize();
  },
  methods: {
    doShuffle() {
      this.myData.forEach((i) => {
        this.results.push({
          done: false,
          answerMsg: "",
          chip: Array.from({ length: 100 }, (_, index) => "grey"),
        });
      });
      console.log(this.myData);
      this.myRandomSeeds = this.getAllSeeds();
    },

    initialize() {
      if (this.sounds.disable == false) {
        let mySound = this.sounds.intro;
        let playedPromise = mySound.play();
        this.sounds.intro.loop = true;
        if (playedPromise) {
          playedPromise.catch((e) => {
            console.log(e.name);
          });
        }
      }
    },

    introCompleted(start, dismusic) {
      //$emitted
      console.log("DISMUSIC", dismusic);
      this.sounds.disable = !dismusic;
      if (start) {
        this.showIntro = false;
        this.stage = 1;
      }
    },
    levelStageCompleted(par1) {
      //$emitted
      this.start(0);
      this.stage = 2;
    },

    start(blockKey) {
      if (blockKey == 0) {
        this.sounds.intro.pause();
        if (this.sounds.disable == false) {
          this.sounds.theme.play();
          this.sounds.theme.loop = true;
        }
      }
      this.timer = Date.now();
      this.hideIntro = true;
      this.blockCount[blockKey] = true;
      this.setTimer();
    },
    check(i, ele, clicked) {
      let myQuestion = this.myData[i];
      let originalDataIndex = 0;
      this.orig.forEach((element,index)=>{
        //console.log("ITERATE ","index",index,"element.q",myQuestion.q,"ele",ele);
        if (element.q == myQuestion.q) {
          originalDataIndex = index;
          console.log("INDEX", originalDataIndex);
        }
      });
      if (this.nextQuestionMsgFlag == 1) {
        return;
      }
      clicked = clicked == undefined ? false : clicked;
      if (clicked == true) {
        this.sounds.click.play();
      }
   
      let rightAnswer = this.myData[i].a;
      if (rightAnswer == ele) {
        this.results[i].answerMsg =
          "<div class='cgAnswerText ok'><img src='images/medal.png'></div>";
        this.timeout(this.sounds.ok.play(), 200);
      } else {
        let ra = "<div class='cgRightAnswerArea'>" + rightAnswer + "</div>";
        this.results[i].answerMsg =
          "<div class='cgAnswerText ko'><img src='images/wrong.png'></div>";
        if (rightAnswer) {
          this.results[i].answerMsg += ra;
        }
        this.timeout(this.sounds.ko.play(), 200);
      }
      let timerDiff = (Date.now() - this.timer) / 1000 ;
      this.timer = +(Math.round(timerDiff + "e+2") + "e-2");
      this.timer = (this.timer > this.SETCOUNTER) ? this.SETCOUNTER : this.timer;
      console.log("THIS TIMER ",this.timer);
      this.results[i].done = true;
      this.scores[i] = {
        question: myQuestion.q,
        yourAnswer: ele,
        rightAnswer: rightAnswer,
        result: rightAnswer == ele ? true : false,
        timer: this.timer,
        dataIndex : originalDataIndex
      };

      this.$refs.chipGroup[i].$children.forEach((val, cnt) => {
        if (val.$el.innerText == rightAnswer) {
          this.results[i].chip[cnt] = "green";
        }
      });
      this.readyForNextQuestion();
    },
    randomSeeds(itemToShow) {
      //prendo tutti gli elementi che non sono in quello da mostrare
      let stack = this.myData.filter((f) => {
        return f.q != itemToShow;
      });
      let arr = [];
      let elems = [];
      let cnt = 0;
      while (arr.length < 4) {
        cnt++;
        let r = Math.floor(Math.random() * stack.length - 1) + 1;
        if (arr.indexOf(r) === -1) arr.push(r);
        if (cnt > 100) break;
      }
      arr.forEach((i) => {
        elems.push(stack[i].a);
      });
      //prendo la risposta dell'elemento da mostrare
      let found = this.myData.filter((p) => {
        return p.q == itemToShow;
      })[0].a;
      elems.push(found);
      elems = this.betterShuffleMethod(elems);
      //this.shuffleArray(elems);
      return elems;
    },
    getAllSeeds() {
      const arr = [];

      this.myData.forEach((dataElement) => {
        arr.push(this.randomSeeds(dataElement.q));
      });
      return arr;
    },

    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },

    setTimer() {
      this.counter = this.SETCOUNTER;
      this.counterFlag = 1;
      if (typeof counterAction != "undefined") {
        clearInterval(this.counterAction);
      }
      this.counterAction = setInterval((a) => {
        if (this.counter == 0) {
          clearInterval(this.counterAction);

          this.counterFlag = 0;
          this.check(this.blockKey(), "");
        } else {
          this.counter--;
        }
        /*
        let $s = document.querySelector(".counter"+this.counter).style;
        $s.fontSize='50px';*/
      }, 1000);
    },
    readyForNextQuestion() {
      this.nextQuestionMsgFlag = 1;
      this.counterFlag = 0;
      setTimeout((a) => {
        this.nextQuestionMsgFlag = 0;
        this.showNextQuestionLogic();
      }, 2000);
    },
    showNextQuestionLogic() {
      if (typeof this.counterAction != "undefined") {
        clearInterval(this.counterAction);
      }
      let nextId = this.nextKey();
      let thisId = this.blockKey();
      console.log(nextId);
      if (nextId > -1) {
        this.blockCount[thisId] = false;
        this.start(nextId);
      }
    },
    blockKey() {
      
      let activeId = this.blockCount
        .map((v, i) => {
          if (v == true) return i;
        })
        .find((f) => {
          return typeof f != "undefined";
        });
      return activeId;
    },
    nextKey() {
      let letsTry = this.blockKey() + 1;
      if (typeof this.myData[letsTry] != "undefined") {
        return letsTry;
      } else {
        this.endScores();
      }
    },
    audioChecked() {},
    timeout(func, ms) {
      setTimeout((f) => {
        func;
      }, ms);
    },
    endScores() {
      this.sounds.theme.pause();
      this.stage = 3;
      this.scoreProps = this.scores;

      console.log(this.scores);
    },
    backToIntro() {
      this.stage = 0;
      this.hideIntro = false;
      this.blockCount = new Array(data.length);
      this.answerMsg = "";
      this.myRandomSeeds = "";
      this.counter = this.SETCOUNTER;
      (this.counterAction = undefined),
        (this.nextQuestionMsgFlag = 0),
        (this.counterFlag = 1),
        (this.time = 0),
        (this.showIntro = true);
      this.results = [];
      this.scores = [];
      this.levelStageKey++;
      this.mainKey++;
      this.doShuffle();
      this.initialize();
    },
    betterShuffleMethod(sourceArray) {
      for (var i = 0; i < sourceArray.length - 1; i++) {
        var j = i + Math.floor(Math.random() * (sourceArray.length - i));

        var temp = sourceArray[j];
        sourceArray[j] = sourceArray[i];
        sourceArray[i] = temp;
      }
      return sourceArray;
    },
  },
};
</script>

<style scoped>
.column-block {
  position: relative;
}
.info-wrapper {
  height: 70px;
}
.counter {
  font-size: 22px;
  animation: counterAnim 1s infinite;
  position: absolute;
  top: 0;
  width: 100px;
  text-align: center;
  left: calc(50% - 50px);
  display: block;
  color: red;
  font-family: "Press Start 2P", cursive;
}

@keyframes counterAnim {
  0% {
    font-size: 16px;
  }
  100% {
    font-size: 80px;
    opacity: 0.4;
  }
}

.questionText {
  font-size: 42px;
}
.questionInfo {
  text-align: center;
  font-family: "Press Start 2P", cursive;
}
.answerChip {
  border: 1px solid #999999 !important;
  box-shadow: 0px 10px 10px 0px rgba(122, 122, 122, 1);
}
.questionResultText {
  margin-top: 22px;
}
.readyNextQuestion {
  font-family: "Press Start 2P", cursive;
  color: blue;
}
</style>
<style>
#app {
  background: none;
}
.cgAnswerText {
  font-size: 22px;
}
.cgAnswerText.ok img {
  width: 100px;
}
.cgAnswerText.ko img {
  width: 100px;
}
.cgRightAnswerArea {
  font-size: 24px;
  color: #f35c5c;
}
</style>